import { Component, Input, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../../core/constants';
import { SummaryForSupplierDTO } from '../../../models/summary-for-supplier-dto';
import { AppGlobalDataService } from '../../../services/appglobaldata.service';
import { LocalstorageService } from '../../../services/localstorage.service';
import { DataService } from 'src/app/services/data.service';
import { ChartProposalStatus } from 'src/app/core/constantEnums';
@Component({
    selector: 'app-openactions',
    templateUrl: './openactions.component.html',
    styleUrls: ['./openactions.component.scss'],
})
export class OpenactionsComponent implements OnInit {
    @Input() selectedTabIndex: number = 0;
    CountBadges: SummaryForSupplierDTO = new SummaryForSupplierDTO();
    locStorage = Constants.localStorageKeys;
    summaryForSupplierDTO: SummaryForSupplierDTO = new SummaryForSupplierDTO();
    supplierChartData: Array<any> = [];
    constructor(
        private localstorageService: LocalstorageService,
        private dataService: DataService,
        private router: Router
    ) {}

    ngOnInit() {
        this.getSummaryForSupplier();
        this.CountBadges = this.localstorageService.retrieve(
            this.locStorage.CountBadges
        );
    }

    getSummaryForSupplier() {
        this.dataService.getSummaryForSupplier().subscribe((response: any) => {
            if (response != null) {
                this.summaryForSupplierDTO = response.Data;
                this.localstorageService.store(
                    this.locStorage.CountBadges,
                    this.summaryForSupplierDTO
                );
                this.supplierChartData = [
                    {
                        label: 'Pending',
                        value: this.summaryForSupplierDTO.Pending || 0,
                        id: ChartProposalStatus.Pending,
                    },
                    {
                        label: 'Submitted',
                        value: this.summaryForSupplierDTO.Submitted || 0,
                        id: ChartProposalStatus.Submitted,
                    },
                    {
                        label: 'Approved',
                        value: this.summaryForSupplierDTO.Approved || 0,
                        id: ChartProposalStatus.Approved,
                    },
                    {
                        label: 'Rejected',
                        value: this.summaryForSupplierDTO.Rejected || 0,
                        id: ChartProposalStatus.Rejected,
                    },
                ];
            }
        });
    }

    getBadgeCountPending() {
        if (this.CountBadges) {
            return this.CountBadges.Pending;
        }
        return null;
    }
    getBadgeCountRejected() {
        if (this.CountBadges) {
            return this.CountBadges.Rejected;
        }
        return null;
    }

    getBadgeCountIncomplete() {
        if (this.CountBadges) {
            return this.CountBadges.Incomplete;
        }
        return null;
    }

    private setCountBadges(data: SummaryForSupplierDTO) {
        console.log(data);
    }

    selectedTabChange(event: MatTabChangeEvent) {
        switch (event.index) {
            case 0: {
                console.log('Pending Proposals');
                this.router.navigate(['/Pendingproposals']);
                break;
            }
            case 1: {
                console.log('Rejected Proposals');
                this.router.navigate(['/Rejectedproposals']);
                break;
            }
            case 2: {
                console.log('Incomplete Proposals');
                this.router.navigate(['/Incompleteproposals'], {
                    queryParams: { openaction: '1' },
                });
                break;
            }
        }
    }
}
